import React, { Component } from "react";

class NotFound extends Component {
  render() {
    return (
      <section className="account">
        <header>
          <h1>Niet gevonden</h1>
          <p>De pagina is niet gevonden.</p>
          <div role="link" onClick={() => window.location = "/"}>
            Terug naar beginpagina
          </div>
        </header>
      </section>
    );
  }
}

export default NotFound;
